/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { dataControllerDataSources } from '../fn/data-controller/data-controller-data-sources';
import { DataControllerDataSources$Params } from '../fn/data-controller/data-controller-data-sources';
import { dataControllerVisuals } from '../fn/data-controller/data-controller-visuals';
import { DataControllerVisuals$Params } from '../fn/data-controller/data-controller-visuals';
import { DataSourcesResponse } from '../models/data-sources-response';
import { Readable } from '../models/readable';


/**
 * Represents API endpoints that provide basic data based on the use case.
 */
@Injectable({ providedIn: 'root' })
export class DataControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `dataControllerDataSources()` */
  static readonly DataControllerDataSourcesPath = '/planning-projects/v1-develop/data/data-sources';

  /**
   * Provide a basic data related to predefined set of data sources.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dataControllerDataSources()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  dataControllerDataSources$Response(params: DataControllerDataSources$Params, context?: HttpContext): Observable<StrictHttpResponse<DataSourcesResponse>> {
    return dataControllerDataSources(this.http, this.rootUrl, params, context);
  }

  /**
   * Provide a basic data related to predefined set of data sources.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dataControllerDataSources$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  dataControllerDataSources(params: DataControllerDataSources$Params, context?: HttpContext): Observable<DataSourcesResponse> {
    return this.dataControllerDataSources$Response(params, context).pipe(
      map((r: StrictHttpResponse<DataSourcesResponse>): DataSourcesResponse => r.body)
    );
  }

  /** Path part for operation `dataControllerVisuals()` */
  static readonly DataControllerVisualsPath = '/planning-projects/v1-develop/data/visuals/{visualId}/{fileType}';

  /**
   * Returns a visual asset by its ID and type.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dataControllerVisuals()` instead.
   *
   * This method doesn't expect any request body.
   */
  dataControllerVisuals$Response(params: DataControllerVisuals$Params, context?: HttpContext): Observable<StrictHttpResponse<Readable>> {
    return dataControllerVisuals(this.http, this.rootUrl, params, context);
  }

  /**
   * Returns a visual asset by its ID and type.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dataControllerVisuals$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dataControllerVisuals(params: DataControllerVisuals$Params, context?: HttpContext): Observable<Readable> {
    return this.dataControllerVisuals$Response(params, context).pipe(
      map((r: StrictHttpResponse<Readable>): Readable => r.body)
    );
  }

}
